import { Routes, Route, Link, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmailNotice from './pages/VerifyEmailNotice';
import AcceptInvitation from './pages/AcceptInvitation';
import CreateOrg from './pages/CreateOrg';
import Landing from './pages/Landing';
import Members from './pages/Members';
import Settings from './pages/Settings';
import CallDetail from './pages/CallDetail';
import Contacts from './pages/Contacts';
import ContactDetail from './pages/ContactDetail';
import Numbers from './pages/Numbers';
import Billing from './pages/Billing';
import Setup from './pages/Setup';
import Support from './pages/Support';
import StaffSetup from './pages/StaffSetup';
import StaffWelcome from './pages/StaffWelcome';
import { SessionGate } from './components/SessionGate';
import { AppShell } from './components/AppShell';

export default function App() {
  return (
    <Routes>
      {/* Public auth routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmailNotice />} />
      <Route path="/accept-invitation" element={<AcceptInvitation />} />
      <Route path="/landing" element={<Landing />} />
      <Route path="/" element={<Navigate to="/setup" replace />} />

      {/* Onboarding sits OUTSIDE the shell — the shell requires an org, but
          /onboarding/create-org is specifically the place users land when
          they don't have one yet. */}
      <Route
        path="/onboarding/create-org"
        element={
          <SessionGate>
            <CreateOrg />
          </SessionGate>
        }
      />

      <Route
        path="/staff/welcome"
        element={
          <SessionGate>
            <StaffWelcome />
          </SessionGate>
        }
      />

      {/* Authenticated app surface: shell + nested pages. */}
      <Route
        element={
          <SessionGate>
            <AppShell />
          </SessionGate>
        }
      >
        <Route path="/setup" element={<Setup />} />
        <Route path="/calls/:sid" element={<CallDetail />} />
        <Route path="/follow-ups" element={<Navigate to="/setup" replace />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/contacts/:phone" element={<ContactDetail />} />
        <Route path="/coaching" element={<Navigate to="/setup" replace />} />
        <Route path="/numbers" element={<Numbers />} />
        <Route path="/devices" element={<Navigate to="/settings" replace />} />
        <Route path="/team" element={<Navigate to="/members" replace />} />
        <Route path="/staff/setup" element={<StaffSetup />} />
        <Route path="/members" element={<Members />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/support" element={<Support />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center p-8">
      <div className="text-center">
        <p className="text-sm text-slate-500">Page not found.</p>
        <Link to="/" className="mt-2 inline-block text-sm text-blue-600 hover:underline">
          Back home
        </Link>
      </div>
    </main>
  );
}
